import React from "react";
import { View } from "@/styles/reactnative";
import CModalHeader from "../Modal/CModalHeader";
import { useTradeModalStore } from "../../../hooks/trade/modalStore";
import DepositLeftSection from "../../../components/DepositModal/DepositLeftSection";

const DepositModal = ({ setShowModal }) => {
  const { data, mutate: mutateModalStore } = useTradeModalStore();

  return (
    <View
      style={{
        alignItems: "flex-start",
        justifyContent: "flex-start",
        width: "100%",
      }}
    >
      <CModalHeader
        title={"deposit"}
        closeModal={() => mutateModalStore({ ...data, depositModal: false })}
      />
      <DepositLeftSection width={"100%"} />
    </View>
  );
};

export default React.memo(DepositModal);
